var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopping1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M866 234L866 262",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 866.5,
    cy: 229.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M863.105 238C862.637 238 862.236 237.834 861.903 237.501C861.57 237.168 861.403 236.767 861.403 236.3C861.403 235.833 861.57 235.432 861.903 235.099C862.236 234.766 862.637 234.6 863.105 234.6C863.573 234.6 863.973 234.766 864.306 235.099C864.64 235.432 864.806 235.833 864.806 236.3C864.806 236.767 864.64 237.168 864.306 237.501C863.973 237.834 863.573 238 863.105 238ZM871.613 238C871.145 238 870.744 237.834 870.411 237.501C870.078 237.168 869.911 236.767 869.911 236.3C869.911 235.833 870.078 235.432 870.411 235.099C870.744 234.766 871.145 234.6 871.613 234.6C872.081 234.6 872.481 234.766 872.814 235.099C873.148 235.432 873.314 235.833 873.314 236.3C873.314 236.767 873.148 237.168 872.814 237.501C872.481 237.834 872.081 238 871.613 238ZM862.382 224.4L864.423 228.65H870.379L872.719 224.4H862.382ZM861.573 222.7H874.122C874.449 222.7 874.697 222.845 874.867 223.136C875.037 223.426 875.044 223.72 874.888 224.018L871.868 229.457C871.712 229.741 871.503 229.96 871.24 230.116C870.978 230.272 870.691 230.35 870.379 230.35H864.041L863.105 232.05H873.314V233.75H863.105C862.467 233.75 861.985 233.47 861.658 232.911C861.332 232.351 861.318 231.795 861.616 231.243L862.764 229.16L859.702 222.7H858V221H860.765L861.573 222.7Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping1);
export default __webpack_public_path__ + "static/media/shopping_1.116a09fc5505561be726acf8d452a5d3.svg";
export { ForwardRef as ReactComponent };